<template>
  <v-app id="materialpro" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
      <router-view />
      <v-btn v-show='!isChannelTalkActive' fab dark large color='#006CB6' @click="showChannelTalk" style="position:absolute;bottom:20px;right:20px;z-index:500;">
        <v-icon>mdi-chat</v-icon>
      </v-btn>
  </v-app>

</template>

<script>

import firebase from "firebase/app";
import "firebase/auth";
import 'firebase/firestore';
import '@firebase/functions';
import crypto from '../src/crypto'
import ChannelTalkService from './channelTalkService'

let db;
let deleteCustomLoginTokenForPayment;

export default {
  name: 'App',

  components: {
    
  },
  data: () => ({
    isChannelTalkActive : false,
  }),
  methods : {
    getJsonFromURL(){
      let strings = window.location.href.split('/');
      //console.log('strings',strings);
      let base64Str = strings[strings.length-1];
      if(base64Str==""){
        return -1;
      }else if(base64Str=="payment"){
        return -2;
      }else if(base64Str=="logedin"){
        return -3;
      }
      let jsonStr = Buffer(base64Str, 'base64').toString('ascii');
      let json = JSON.parse(jsonStr);
      return json;
    },
    async checkIsTokenAvailable(token){
      try {
        const CryptoJS = require('crypto-js');
        let hashedToken = CryptoJS.SHA512(token);
        //console.log('token is ...', token);
        //console.log('hashed token is ... ',hashedToken);
        let tokenRef = db.collection('custom_tokens').doc('SHA512_' + hashedToken);
        let tokenDoc = await tokenRef.get();
        if(tokenDoc.exists){
          console.log('The token is exists');
          if(tokenDoc.data().isReady){
            return true;
          }else{
            return false;
          }
          
        }else{
          console.log('The token is not exists');

          return false;
        }
        
      } catch (error) {
        console.log('Error on checkIsTokenAvailable', error);
        return false;
      }


    },
    showChannelTalk(){
      try {
        console.log('on showChannelTalk');
        let userData = this.$store.state.userData;
        if(userData && userData.name && userData.email){
          ChannelTalkService.updateUser(userData.name,userData.email);
        }
        ChannelTalkService.show();
      } catch (error) {
        console.log('on showChannelTalk',error);
      }

    }
  },
  computed : {
    userData: {
      get() {
        return this.$store.state.userData;
      },
      set(val) {
        this.$store.commit("SET_USERDATA", val);
      }
    },
    companyId: {
      get() {
        return this.$store.state.companyId;
      },
      set(val) {
        this.$store.commit("SET_COMPANYID", val);
      }
    }
  },
  mounted(){

    try {

      ChannelTalkService.boot({
        'pluginKey': '4aa11d7f-6919-4ebd-9089-f2a7b2e47cb7',
        'hideDefaultLauncher': true,
        'profile': {
          'name': 'beforeLogin',
          'email': 'beforeLogin',
          'from': 'dashboard',
          // 'CUSTOM_VALUE_2': 'VALUE_2'
        },
        // 'memberHash': 'will be supported on Sep 18, 2020'
      }, (error, user) => {
        if(error){
          console.error(`ChannelTalk boot failed`, user,error)
        }else{
          //ChannelTalkService.show();
        }
      });

      ChannelTalkService.onHide(()=>{
        this.isChannelTalkActive = false;
      });

      ChannelTalkService.onShow(()=>{
        this.isChannelTalkActive = true;
      });




      db = firebase.firestore();
      
      let functions = firebase.app().functions('asia-northeast1');
      deleteCustomLoginTokenForPayment = functions.httpsCallable('deleteCustomLoginTokenForPayment');
      let token = '';
      //console.log(window.location.href);
      let json = this.getJsonFromURL();
      //console.log('json',json);
      if(json == -1){
        //console.log('userData',this.userData);
        if(this.userData){
          console.log('push to payment');
          //this.$router.push('/payment')
          return;
        }else{
          console.log('push to login');
          this.$router.push('/authentication/login');
          return;
        }
        
      }else if(json == -3){
          setInterval(()=>{
            console.log('On App interval',this.userData);
          },2000);
          return;
      }
      token = crypto.decrypt(json.token);
      this.companyId = crypto.decrypt(json.companyId);
      //console.log('token is ' , token);
      //console.log('companyId is ' , this.companyId);
      //let isTokenAvailable =  this.TokenAvailable(token);


      const CryptoJS = require('crypto-js');
      let hashedToken = CryptoJS.SHA512(token);
      //console.log('token is ...', token);
      //console.log('hashed token is ... ',hashedToken);
      let tokenRef = db.collection('custom_tokens').doc('SHA512_' + hashedToken);
      tokenRef.get().then((doc)=>{
        if(doc.exists){
          firebase.auth().signInWithCustomToken(token)
          .then(async () => {
            //console.log(result);

            await deleteCustomLoginTokenForPayment({companyId:this.companyId,token:token});
            this.$router.push('/payment')
            
          })
          .catch((error) => {
            console.error("Error on login", error);
          });
        }else{
          console.log('The token is expired or revoked.');
          this.$router.push('/authentication/login');
        }

      });




    } catch (error) {
      console.error('Error on mounted', error);
      //this.$router.push('/authentication/login')
    }

    
  }

};
</script>
